import { createFileRoute } from "@tanstack/react-router";
import { Box, Spinner } from "@salestrak/ui";
import { useWebhooks, useWebhookMutations } from "#app/hooks/settings/use-webhook-mutations";
import { WebhookFormView } from "#app/components/settings/webhook-form-view";
import type { CreateWebhookInput } from "#app/lib/data";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { withPermission } from "#app/components/permissions/require-permission";

function WebhookEditPage() {
  const { webhookId } = Route.useParams();
  const { replace } = useAppNavigate();
  const { webhooks, isLoading } = useWebhooks();
  const { updateWebhook } = useWebhookMutations();

  const webhook = webhooks.find((w) => w.webhookId === webhookId);

  if (isLoading && !webhook) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Spinner />
      </Box>
    );
  }

  if (!webhook) {
    replace("/settings/api");
    return null;
  }

  async function handleSubmit(data: CreateWebhookInput) {
    await updateWebhook(webhookId, data);
    replace(`/settings/api/webhooks/${webhookId}`);
  }

  return (
    <WebhookFormView
      webhook={webhook}
      onCancel={() => replace(`/settings/api/webhooks/${webhookId}`)}
      onSubmit={handleSubmit}
    />
  );
}

export const Route = createFileRoute(
  "/(app)/$workspace/settings/api/webhooks/$webhookId/edit",
)({ component: withPermission("workspace.integrations", WebhookEditPage) });
